import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  xhttpResponse;
  phploc: string = JSON.parse(window.localStorage.getItem('phploc'));
  random_string: string;
  token: string;


  iduser: string = window.sessionStorage.getItem('iduser');
  check_token: string;
  check_random_string: string;


  //authorized: string = window.localStorage.getItem('authorized');


  constructor(private router: Router, private alert: AlertController, private translate: TranslateService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    var xhttp = new XMLHttpRequest();
    xhttp.responseType = 'json';

    var data = new FormData();
    data.append("iduser", this.iduser);
    xhttp.open("POST", this.phploc + "/session.php", true);
    xhttp.send(data);
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4) {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
          if (xhttp.response == null) {
            this.iduser = "";
          }
          else {
            this.xhttpResponse = xhttp.response;
            this.random_string = this.xhttpResponse['random_string'];
            this.token = this.xhttpResponse['token'];
            this.check_token = window.sessionStorage.getItem('token');
            this.check_random_string = window.sessionStorage.getItem('random_string');
          }
        }
        else {
          var networkConnectionError;
          this.translate.get('networkConnectionError').subscribe((res: string) => {
            networkConnectionError = res;
          });
          alert(networkConnectionError + xhttp.status);
        }
      }
    }
    var loginPage = JSON.parse(window.sessionStorage.getItem('loginPage'));
    if (this.token === this.check_token && this.random_string === this.check_random_string) {
      if ((typeof (this.token) != 'undefined' && typeof (this.random_string) != 'undefined') || loginPage == 1) {
        return true;
      } else {
        this.showAlert();
        return this.router.parseUrl('/login');
      }
    } else {
      this.showAlert();
      return this.router.parseUrl('/login');
    }

  }


  async showAlert() {
    var alertTitle, alertTitle2;
    let alert = await this.alert.create({
      header: "" + this.translate.get('unauthorized').subscribe((res: string) => {
        alertTitle = res;
      }),
      message: "" + this.translate.get('youAreNotAuthorized').subscribe((res: string) => {
        alertTitle2 = res;
      }),
    });
    this.presentAlert(alertTitle, alertTitle2);
  }
  async presentAlert(header, message) {
    let alert = this.alert.create({
      header: header,
      subHeader: message,
      buttons:
        [
          {
            text: 'Ok',
            role: 'Ok',
            cssClass: 'okbutton',
            handler: () => {
            }
          },
        ]
    });
    await (await alert).present();
  }
}